var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInfoDefault = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#9FA2B4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05037 4.7C8.51981 4.7 8.90037 4.31944 8.90037 3.85C8.90037 3.38056 8.51981 3 8.05037 3C7.58092 3 7.20037 3.38056 7.20037 3.85C7.20037 4.31944 7.58092 4.7 8.05037 4.7ZM7.15039 12.0884C7.15039 12.5088 7.53095 12.8496 8.00039 12.8496C8.46983 12.8496 8.85039 12.5088 8.85039 12.0884L8.85039 7.6108C8.85039 7.19041 8.46983 6.84961 8.00039 6.84961C7.53095 6.84961 7.15039 7.19041 7.15039 7.6108L7.15039 12.0884Z",
    fill: "#F0F1F7"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfoDefault, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/info-default.bebde736.svg";
export { ForwardRef as ReactComponent };